import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Button, Checkbox, FormGroup } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import baseUrl from '../../config/config';
import { makeStyles } from '@material-ui/styles';

export default function Defects(props){

    const [selectedDefects, setSelectedDefects] = useState([]);
    const [isDefects, setIsDefects] = useState();

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    const handleIsDefect = (e)=>{
        setIsDefects(e.target.value)
        if (e.target.value ==="yes"){
            props.setIsDefects(true)
        }else if(e.target.value ==="no"){
            props.values.property_defect_id = [];
            props.setIsDefects(false)
        }
    }

    return(
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0 mb-4">
                    Are you aware of any significant defects or malfunctions in any of the following?
                </h4>
                <div className='pt-2 form-content-field defects-main'>
                    {/* <div className="py-2">
                        <RadioGroup
                            row 
                            name="is_any_defects"
                            value={props.values.is_any_defects}
                            onChange={props.handleChange}
                            >
                            <div>
                                <FormControlLabel value="yes" checked={props.isDefects === true} onClick={(e)=>handleIsDefect(e)} control={<StyledRadio />} label="Yes" />
                            </div>
                            <div>
                                <FormControlLabel value="no" checked={props.isDefects === false} onClick={(e)=>handleIsDefect(e)} control={<StyledRadio />} label="No" />
                            </div>
                        </RadioGroup>
                    </div>
                    {props.isDefects === true?
                    <>*/}
                    <p>if yes, check appropriate boxes below</p> 
                    <FormGroup className='defects-grp' name="property_defect_id" value={props.values.property_defect_id} onChange={props.handleChange}>
                    {props.defectsList && props.defectsList.map((defect, index) => {
                         return (
                                    <div key={defect.property_defect_id}>
                                        <FormControlLabel
                                            control={<Checkbox disableripple="true" style={{ color:props.values.property_defect_id.includes(defect.property_defect_id.toString()) ? '#295086' : undefined }} checked={props.values.property_defect_id.includes(defect.property_defect_id.toString())} />}
                                            name="property_defect_id"
                                            label={defect.property_defect_name}
                                            value={defect.property_defect_id}
                                            onChange={props.handleChange}
                                        />
                                    </div>
                                )
                        })}
                    </FormGroup>
                    {/* </>:""
                    } */}
                </div>    
            </div>
        </div>    
    )
}